// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"Charts_chartContainer__3ukL0","chartTitle":"Charts_chartTitle__B94p3","globalChart":"Charts_globalChart__2qH5k","dropdown":"Charts_dropdown__19Z8L"};